import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

// Opens Bootstrap dropdowns on hover (desktop only). Attach to the navbar element.
export default class extends Controller {
  static values = {
    breakpoint: { type: Number, default: 992 }
  }

  connect() {
    this.boundMouseEnter = this.handleMouseEnter.bind(this)
    this.boundMouseLeave = this.handleMouseLeave.bind(this)
    this.hideTimeout = null
    this.bound = false

    if (window.innerWidth >= this.breakpointValue) {
      this.bindHover()
    }
    window.addEventListener("resize", this.boundResize = this.handleResize.bind(this))
  }

  disconnect() {
    this.unbindHover()
    window.removeEventListener("resize", this.boundResize)
  }

  handleResize() {
    if (window.innerWidth >= this.breakpointValue) {
      this.bindHover()
    } else {
      this.unbindHover()
    }
  }

  bindHover() {
    if (this.bound) return
    this.bound = true
    this.element.querySelectorAll(".nav-item.dropdown").forEach((el) => {
      el.addEventListener("mouseenter", this.boundMouseEnter)
      el.addEventListener("mouseleave", this.boundMouseLeave)
    })
  }

  unbindHover() {
    if (!this.bound) return
    this.bound = false
    this.element.querySelectorAll(".nav-item.dropdown").forEach((el) => {
      el.removeEventListener("mouseenter", this.boundMouseEnter)
      el.removeEventListener("mouseleave", this.boundMouseLeave)
    })
  }

  handleMouseEnter(e) {
    clearTimeout(this.hideTimeout)
    const toggle = e.currentTarget.querySelector(".dropdown-toggle")
    if (toggle) {
      const bsDropdown = Dropdown.getOrCreateInstance(toggle)
      bsDropdown.show()
    }
  }

  handleMouseLeave(e) {
    const toggle = e.currentTarget.querySelector(".dropdown-toggle")
    if (toggle) {
      const bsDropdown = Dropdown.getInstance(toggle)
      if (bsDropdown) {
        this.hideTimeout = setTimeout(() => bsDropdown.hide(), 200)
      }
    }
  }
}
